import type { IconContainerProps } from './typings'

import { IconContainer } from './elements/IconContainer'

export function EmptyMail(props: IconContainerProps) {
  return (
    <IconContainer {...props}>
      <svg viewBox="0 0 48 48">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 8V9H10.3932L10.4689 9.05434L9.88571 9.86667L8.39999 8.8C8.51502 8.68497 8.64658 8.56995 8.78993 8.46444C8.93484 8.35777 9.09179 8.26083 9.25586 8.18343C9.4939 8.07115 9.74695 8 9.99999 8H12ZM12.1143 11.4667L12.6975 10.6543L15.6689 12.7877L15.0857 13.6L12.1143 11.4667ZM17.3143 15.2L17.8975 14.3877L20.8689 16.521L20.2857 17.3333L17.3143 15.2ZM22.5143 18.9333L23.0975 18.121L24.0089 18.7753L24.9334 18.1317L25.5048 18.9524L24 20L22.5143 18.9333ZM27.7619 17.381L27.1905 16.5603L30.2001 14.465L30.7714 15.2857L27.7619 17.381ZM33.0286 13.7143L32.4572 12.8936L35.4667 10.7984L36.0381 11.619L33.0286 13.7143ZM38.2952 10.0476L37.7239 9.22693L38.0486 9.00087C38.0325 9.00029 38.0163 9 38 9H36V8H38C38.4099 8 38.7673 8.10503 39.0723 8.28818C39.2219 8.37809 39.359 8.48683 39.4833 8.61121C39.5744 8.70227 39.6587 8.8017 39.7361 8.90827C39.758 8.93829 39.7792 8.96888 39.8 9L38.2952 10.0476ZM15 8V9H19V8H15ZM22 8V9H26V8H22ZM29 8V9H33V8H29Z"
          fill="#4383CC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.5 11.8571V10H9.5V11.8571H8.5ZM40 10V11.8571H39V10H40ZM8.5 18.3571V14.6429H9.5V18.3571H8.5ZM40 14.6429V18.3571H39V14.6429H40ZM8.5 24.8571V21.1429H9.5V24.8571H8.5ZM40 21.1429V24.8571H39V21.1429H40ZM8.5 27.6429H9.5V29H11.1786V30H8.5V27.6429ZM40 27.6429V30H37.3214V29H39V27.6429H40ZM18.8036 30H14.4464V29H18.8036V30ZM26.4286 30H22.0714V29H26.4286V30ZM34.0536 30H29.6964V29H34.0536V30Z"
          fill="#4383CC"
        />
        <path
          d="M44 24V38C44 39 43 40 42 40H6C5 40 4 39 4 38V24C4 23 5 22 6 22H15C15.8 22 16.4 22.4 16.8 23L19.2 28H28.8L31.2 23C31.6 22.4 32.2 22 33 22H42C43 22 44 23 44 24Z"
          fill="#0E4686"
        />
      </svg>
    </IconContainer>
  )
}
